export default __webpack_public_path__ + "static/media/Love_HTB.557e4a3f.md";